<script setup lang="ts">
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import { SnsPlatform } from "@/types/sns/SnsPlatform";

const emits = defineEmits(["click"]);

const onClick = (platform: SnsPlatform) => {
  emits("click", platform);
};
</script>

<template>
  <div class="d-flex sns-list mt-3">
    <div class="icon-wrapper line" @click="onClick('line')" data-testid="line">
      <img
        class="icon-inner"
        src="@/assets/img/sns/line.png"
        height="40"
        width="40"
      />
    </div>
    <div
      class="icon-wrapper email"
      @click="onClick('email')"
      data-testid="email"
    >
      <FeatherIcon class="icon-inner" icon="mail" size="24" color="white" />
    </div>
    <div class="icon-wrapper x" @click="onClick('x')" data-testid="x">
      <img
        class="icon-inner"
        src="@/assets/img/sns/x.png"
        height="20"
        width="20"
      />
    </div>
    <div
      class="icon-wrapper facebook"
      @click="onClick('facebook')"
      data-testid="facebook"
    >
      <img
        class="icon-inner"
        src="@/assets/img/sns/facebook.png"
        height="24"
        width="24"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.sns-list {
  gap: 0.5rem;

  .line {
    background-color: #06c755;
  }

  .email {
    background-color: #3191eb;
  }

  .facebook {
    background-color: #3f80eb;
  }

  .x {
    background-color: #333;
  }

  .icon-wrapper {
    position: relative;
    flex: 1 1 auto;
    height: 40px;
    cursor: pointer;
    border-radius: 4px;

    .icon-inner {
      position: absolute;
      inset: 0;
      margin: auto;
    }
  }
}
</style>
